module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAMklEQVQ4y2O4IcdKNmIYfJo/bVoFRyRr/o8Ehq1mYMD8JwIgh9+Q1zwS45maGWNwFwYAEAs+Hwj/gFMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ch.png
// module id = 794
// module chunks = 0